<template lang="jade">
  #referral-page.page
    navbar(:user="user")
    el-popover(ref="contractdata"
      placement="bottom",
      v-model="isShowContractDataPopover",
      width="320",
      trigger="manual")
      div(style="text-align:center;")
        h3(style="font-size:18px;line-height:2em") Your contract will expire in {{user.expiresDay}}.
        p(style="font-size:14px") If you would like to renew it, please contact &nbsp;
         a(href="mailto:affiliate@vipkid-intl.com") affiliate@vipkid-intl.com
        el-button(style="width:8em;margin:1em", @click="closeContractDataPopover") OK
    .page-title Referrals Query
      span.contract-info
        b Contract Date
        span.el-icon-information(@click="toggleContractDataPopover", ref="infoicon", v-if="user.expires", v-popover:contractdata="", style="margin:3px;cursor:pointer;color:#73ba00")
        | &nbsp; {{user.contractStartTime}} - {{user.contractEndTime}}
    hr
    .the-query-bar
      query-bar(@querychanged="queryChanged")
    .data-list
      span(style="line-height:2em") Total Records: {{total}}
      el-table(:class="{empty:total === 0, loading: loading}", :data="tableData", :empty-text="tableStatusText", :show-header="tableData.length > 0")
        el-table-column(prop="name", label="Name")
        el-table-column(prop="username", label="Email")
        el-table-column(prop="mobile2", label="Mobile Phone")
        el-table-column(prop="applyDate", label="Apply Date")
        el-table-column(prop="lifeCycle", label="Life Cycle")
        el-table-column(prop="status", label="Status")
        el-table-column(prop="result", label="Result")
        el-table-column(prop="regularDate", label="Become regular teacher")
        el-table-column(prop="scheduledDateTime", label="Teach 1st class")
      el-pagination(v-if="total > pageSize",
        @current-change="onCurrentPageChange",
        layout="prev,pager,next",
        :current-page="currentPage",
        :page-size="pageSize",
        :total="total")
</template>
<style lang="stylus">
#referral-page
  .contract-info
    float: right
    font-size: 16px
    line-height: 4

  // overwrite
  .el-table.empty, .el-table.loading
    border: none
    overflow: hidden
    &:before
      height: 0px !important
    .el-table__body-wrapper
      overflow: hidden
      height: 200px

  .data-list
    .el-table__header-wrapper thead div
      background-color: transparent
    .el-table
      border-left: none
      td
        border: 1px solid #f0f0f0 !important
        border-left: none !important
      th
        border-right: 1px solid #f0f0f0
        background-color: #fafafa
        border-top: 2px solid #afafaf
        border-bottom: 1px solid #afafaf
      td:last-child, th:last-child
        border-right: none !important
      td, th.is-leaf
        border-bottom: 1px solid #afafaf
        height: 52px
      &:after
        width: 0
      &::before
        height: 2px
        background-color: #afafaf
      .el-input-group__append .el-button
        background-color: #676767
        border-radius: 0

  @-moz-document url-prefix()
    .data-list
      td, th.is-leaf
        background-clip: content-box
</style>
<style lang="stylus" scoped>
  .page > div
    margin: 30px 50px 26px 50px

  hr
    margin: 0 50px
    height: 2px
    line-height: 2px
    border: none
    background: #979797

  .page-title
    font-size: 32px
</style>

<script>
import Navbar from 'components/navbar'
import QueryBar from './query-bar.vue'
import Referral from 'api/referral.api.js'
import { ElementMessageMixin } from 'api/utils.js'

export default {
  mixins: [ ElementMessageMixin ],
  props: ['user'],
  data () {
    return {
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      searchParam: {},
      loading: false,
      isShowContractDataPopover: false
    }
  },
  computed: {
    tableStatusText () {
      if (this.loading) {
        return 'Loading...'
      } else if (this.total === 0) {
        return 'Oops! Couldn’t find any records'
      } else {
        return ''
      }
    }
  },
  mounted () {
    // debug purpose only, DO NOT USE
    window.$referralpage = this
    if (this.user.email) {
      this.search()
      this.showContractDataPopover()
    }
  },
  methods: {
    /**
     * reset table data and loading status
     * @param  {Array} data
     */
    reset (data) {
      this.tableData = data || []
      this.loading = false
    },
    /**
     * do the searching
     * @param  {Object} params search parameters
     */
    search (params) {
      if (params) {
        this.searchParam = params
      } else {
        params = this.searchParam
      }
      params.page = this.currentPage

      /**
       * dataType can be empty
       * but once not empty, the 'start date' and 'end date' is mandatory
       */
      if (params.dataType) {
        if (!params.startTime) {
          this.$warning('Please set start date')
          return
        }
        if (!params.endTime) {
          this.$warning('Please set end date')
          return
        }
        // 'end date' must later than 'start date'
        // otherwise there will be not data in search result
        if (params.startTime > params.endTime) {
          this.$warning('End date must after Start date')
          return
        }
      }

      const errorMsg = 'Fail to get data from server, please try later.'
      this.loading = true
      this.tableData.length = 0
      Referral.search(params).then(e => {
        if (e.data.success) {
          if (e.data.data.list && e.data.data.list.length > 0) {
            e.data.data.list.forEach((it) => {
              it.mobile2 = `${it.codes} ${it.mobile}`
            })
          }
          this.reset(e.data.data.list)
          this.total = e.data.data.count
        } else {
          this.reset()
          this.$error(errorMsg)
        }
      }).catch(e => {
        console.error(e)
        this.reset()
        this.$error(errorMsg)
      })
    },
    queryChanged (query) {
      // reset current page to 1 when query parameters is changed
      this.currentPage = 1
      this.searchParam = query
      this.search()
    },
    onCurrentPageChange (page) {
      this.currentPage = page
      this.search()
    },
    closeContractDataPopover () {
      this.isShowContractDataPopover = false
    },
    toggleContractDataPopover () {
      this.isShowContractDataPopover = !this.isShowContractDataPopover
    },
    showContractDataPopover () {
      if (this.user.expires) {
        setTimeout(_ => {
          this.isShowContractDataPopover = true
        }, 1000)
      }
    }
  },
  watch: {
    /**
     * User is empty before Referral.getUserInfo returned.
     * Once we get user info do the search witouth any parameters
     */
    'user.email': function () {
      if (this.user.email) {
        this.search()
        this.showContractDataPopover()
      }
    }
  },
  components: {
    'query-bar': QueryBar,
    'navbar': Navbar
  }
}
</script>



// WEBPACK FOOTER //
// referral.vue?3403075c